import React from "react";
import "../styles/common.css";
import "../styles/footer.css";

import logo from "../img/common/logo.svg";
import facebook from "../img/icon/icon_facebook.svg";
import instagram from "../img/icon/icon_instagram.svg";
import linkedin from "../img/icon/icon_linkedin.svg";

function Footer() {
  return (
    <footer>
      <div className="footer-container">
        <div className="footer-container__menu">
          <div className="footer-logo">
            <img src={logo} alt="LOGOT" />
          </div>
          <nav className="footer-nav">
            <ul>
              <li><a href="/work">制作実績</a></li>
              <li><a href="/website">Webサイト制作</a></li>
              <li><a href="/marketing">マーケティング支援</a></li>
              <li><a href="/branding">ブランディング支援</a></li>
              {/* <li><a href="/news">ニュース</a></li> */}
              {/* <li><a href="/blog">ブログ</a></li> */}
              <li><a href="/company">会社概要</a></li>
            </ul>
          </nav>
          <div className="footer-buttonArea">
            <div className="button-gradation button-contact button-icon footer-button">
              <a href="/contact"><span>お問い合わせ</span></a>
            </div>
            {/* <div className="button-black button-document button-icon footer-button">
              <a href="/"><span>資料請求</span></a>
            </div> */}
          </div>
        </div>
        <div className="footer-container__under">
          <div className="footer-sns">
            <div className="footer-sns__title">
              <p>Follow US</p>
            </div>
            <div className="footer-sns__box">
              <div className="footer-snsBox__item">
                <p>LOGOT SNS</p>
                <ul className="footer-snsBox__button">
                  <li>
                    <a href="https://www.facebook.com/LOGOTUG" target="_blank" rel="noopener noreferrer">
                    <img src={facebook}/>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/logot.ug/" target="_blank" rel="noopener noreferrer">
                    <img src={instagram}/>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.linkedin.com/company/logot-ug/" target="_blank" rel="noopener noreferrer">
                    <img src={linkedin}/>
                    </a>
                  </li>
                </ul>
              </div>
              <div className="footer-snsBox__item">
                <p>Pomes Midori SNS</p>
                <ul className="footer-snsBox__button">
                  <li>
                    <a href="https://www.facebook.com/pmesmidori/" target="_blank" rel="noopener noreferrer">
                    <img src={facebook}/>
                    </a>
                  </li>
                  <li>
                    <a href="https://www.instagram.com/pomes_midori" target="_blank" rel="noopener noreferrer">
                    <img src={instagram}/>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          
        </div>
        
      </div>
      <div className="copyright">
        <small>(c) LOGOT co. inc</small>
        <ul className="footer-regel_button">
          <li><a href="/datenschutzerklarung">Datenschutzerklärung</a></li>
          <li><a href="/impressum">Impressum</a></li>
          <li><a href="/cookiePolicy">Cookie Policy</a></li>
          <li><a href="/agb">AGB</a></li>
        </ul>
      </div>
    </footer>
  );
}

export default Footer;
